module.exports = __webpack_public_path__ + "assets/icons/ic_visibility_off-03ae.svg";